import { useState, useEffect } from "react";

export default function useToken() {
  const removeExpiringToken = (key) => {
    localStorage.removeItem(key);
  };

  // Check for auth token in URL (from Ruby app redirect)
  const checkUrlForToken = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get("auth_token");
    const authData = urlParams.get("auth_data");

    if (authToken) {
      // Save the token
      const now = Date.now();
      const expirationTime = 18000 * 1000;
      localStorage.setItem(
        "access_token",
        JSON.stringify({
          userToken: authToken,
          expiration: now + expirationTime,
        })
      );

      // If we have auth data, decode and store it
      if (authData) {
        try {
          const decodedData = JSON.parse(atob(authData));
          localStorage.setItem("userData", JSON.stringify(decodedData));
        } catch (e) {
          console.error("Failed to decode auth data:", e);
        }
      }

      // Clean the URL (remove auth params)
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);

      return authToken;
    }
    return null;
  };

  const getToken = () => {
    // First check URL for token (from redirect)
    const urlToken = checkUrlForToken();
    if (urlToken) {
      return urlToken;
    }

    var object = JSON.parse(localStorage.getItem("access_token"));
    if (object == null) {
      return null;
    }
    var dateString = null;
    var now = null;
    if (object) {
      dateString = object.expiration;
      now = new Date().getTime().toString();
    }
    if (!object || now > dateString) {
      if (object.userToken !== undefined) {
        removeExpiringToken("access_token");
      }
      return null;
    }
    return object.userToken === "undefined" || object.userToken === undefined
      ? null
      : object.userToken;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    const now = Date.now();
    const expirationTime = 18000 * 1000;
    localStorage.setItem(
      "access_token",
      JSON.stringify({ userToken, expiration: now + expirationTime })
    );
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token,
  };
}
